module.exports = __webpack_public_path__ + "img/project-3.e8d9ad0e.jpg";